export const meta: BlockMeta = {
  title: "Partners Item",
  description: "A single partners block item",
  keywords: ["content"],
  icon: "book-alt",
  category: "layouts",
}

import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { tv } from "tailwind-variants"

const variants = tv({
  base: "relative h-0 overflow-hidden pt-[56.25%]",
  variants: {
    admin: {
      true: "",
    },
  },
  defaultVariants: {
    admin: false,
  },
})

export default defineBlock("content/partners-item", (props) => {
  return (
    <div className={variants({ admin: env.admin })}>
      <div className="absolute left-0 top-0 w-full h-full [&_div]:!h-full [&_div]:!m-0">
        <InnerBlocks
          allowedBlocks={["content/image-scaleable"]}
          template={[["content/image-scaleable", null]]}
          templateLock="all"
        />
      </div>
    </div>
  )
})
